module.exports = __webpack_public_path__ + "static/media/enageed_logo.25bfb797.png";